import { useMutation } from '@tanstack/react-query';

import { CabinEventClient, DeleteRequest } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const cabinEventClient = new CabinEventClient(apiBaseUrl);

function useDeleteCabinEventDraft() {
  return useMutation({
    mutationKey: [queryKeys.CabinEvent.Delete],
    mutationFn: (request: DeleteRequest) => cabinEventClient.delete(request),
  });
}

export default useDeleteCabinEventDraft;
